/**
 * Returns a callback to initialize the slick behavior.
 * @param {Element} component
 * @return {Function} A callback function
 */
const handleDefaultInit = (component) => () => {
    const $pager = $('<span data-itemSlider-pager>');

    $(component)
        .on('init', () => {
            $(component).append($pager);
        }).on('init afterChange', (event, slick) => {
            $pager.text(`${slick.currentSlide + 1} / ${slick.slideCount}`);
        }).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            focusOnSelect: true,
            centerMode: true,
            dots: false,
            arrows: false,
            infinite: false,
            variableWidth: true,
        });
};

export default handleDefaultInit;



// WEBPACK FOOTER //
// ./src/scripts/components/item-slider/handleDefaultInit.js